<!-- 辅导信息详情 -->
<template>
  <div class="project-coach-info-detail">
    <div class="info-large">
      <h1>{{projectDetail.univer}}</h1>
      <span>{{projectDetail.location}}</span>
    </div>
    <div class="info-small">
      <h2>{{projectDetail.overseasName}}</h2>
      <span>Application DDL: {{projectDetail.rolling === 1?'rolling':projectDetail.deadlineTime}}</span>
    </div>
    <!-- 评价导师 -->
    <evaluate-mentor-modal ref="evaluate"
                           @on-success="getSingleProject"
                           @on-close="handleCloseEvaluate"></evaluate-mentor-modal>
  </div>
</template>

<script>
// api
import { getProjectBasicDetail } from '@/api/project'
import { getMaterialSingleProject, getMaterialQueryModuleFinishProject } from '@/api/material'
import EvaluateMentorModal from './evaluate-mentor'
import { mapMutations } from 'vuex'
import { ESSAY_EVALUATE, setEvaluate, getEvaluate } from '@/libs/util'
export default {
  name: 'project-coach-info-detail',
  components: {
    EvaluateMentorModal
  },
  data () {
    return {
      programId: this.$route.params.id,
      projectDetail: {},
      moduleFinish: false
    }
  },
  computed: {},
  mounted () {
    this.getProjectBasicDetail()
    this.getMaterialQueryModuleFinishProject()
  },
  methods: {
    ...mapMutations(['setProjectDetail']),
    getProjectBasicDetail () {
      getProjectBasicDetail({
        id: this.programId
      }).then(res => {
        this.projectDetail = res.data.model
        this.setProjectDetail(res.data.model)
      })
    },
    getMaterialQueryModuleFinishProject () {
      getMaterialQueryModuleFinishProject({}).then(res => {
        this.moduleFinish = (res.data && res.data.model && res.data.model.moduleFinish) || false
        this.getSingleProject()
      })
    },
    // 获取list
    getSingleProject () {
      if (getEvaluate(ESSAY_EVALUATE) || this.$route.name === 'project-essay-modify') return false
      getMaterialSingleProject({
        id: this.programId
      }).then(res => {
        let bills = (res.data.model && res.data.model.progress && res.data.model.progress.bills) || []
        for (let i = 0; i < bills.length; i++) {
          let smEdit = bills[i].smEdit || []
          if (this.hasModal(smEdit, 'sm', bills[i].id)) break
          let emEdit = bills[i].emEdit || []
          if (this.hasModal(emEdit, 'em', bills[i].id)) break
        }
      })
    },
    hasModal (edit, type, billId) {
      let hasIndex = edit.findIndex(item => item.status === 'EDITED' && item.evaluateStatus === 'NO_EVALUATE')
      if (edit.length && hasIndex > -1) {
        let simple = edit.length !== (hasIndex + 1)
        this.singleDate = edit[hasIndex]
        this.$refs['evaluate'].showHandle(simple, this.moduleFinish, this.singleDate, {
          editType: type === 'sm' ? 'SMEDIT' : 'EMEDIT',
          billId
        })
        return true
      }
      return false
    },
    handleCloseEvaluate () {
      setEvaluate(ESSAY_EVALUATE, true)
    }
  }
}
</script>
<style lang='less' scoped>
</style>
